let casePassword = undefined;

export const authProvider = {
  headers: async () => {
    if (casePassword) {
      return {
        'synergilife-case-authorization': casePassword
      };
    }
    return {};
  },
  processResponse: async (responsePromise: Promise<Response>) => {
    const response = await responsePromise;
    if (response.headers.has('synergilife-case-authorization')) {
      casePassword = response.headers.get('synergilife-case-authorization');
    }
    return response;
  },
  setAuthorization: (auth: string) => {
    casePassword = auth;
  },
  getAuthorization: (): string => casePassword,
  get redirectStarted() { return false },
  get isAnonymous() { return true }
};
